exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".canary-config-section .col-md-6,\n.canary-config-section .col-md-8 {\n  margin-top: 5px;\n}\n", ""]);

